// ACRYLMALL 価格表 iframe 切り替え
//
// 商品ページの「営業日出荷 (7/8/9/10) コンボボックス」または
// 「納品プラン (通常納品プラン/特急納品プラン)」の選択値に応じて、
// 表示する Google Sheets pubhtml URL を切り替える。
//
// 商品分類:
//   - 通常商品 (NORMAL_GIDS のキー):  acrylstand, acrylkeyholder, ... など
//                                     combo 値は「N営業日出荷」(N = 7/8/9/10)
//   - イベント商品 (-event suffix / m3- / c107- prefix):
//                                     combo 値は「通常納品プラン」「特急納品プラン」
//                                     URL は base 商品名 (acrylstand など) で決まる
//                                     prefix が違っても URL は同一なので alias 扱い
//
// 価格表 UI が無い商品ページ (combo box 未設置) では何もせず return する。
//
// 旧版は eventProducts 配列に "-event" suffix の 3 件しか登録しておらず、
// m3-* / c107-* の商品は通常商品扱いになって selectedValue.replace("営業日出荷", "")
// を通っていた (replace は空振りで偶然動作)。今版は商品名から type を判定するので
// 矛盾が無くなる。

document.addEventListener("DOMContentLoaded", () => {
  // ===== 1. URL 設定 =====
  const SHEET_BASE       = "https://docs.google.com/spreadsheets/d/19O8a1-RzBneHT4dGPkOOzJsi9nhQKcQPgc28e912szM/pubhtml";
  const EVENT_SHEET_BASE = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTurYiMu-NyePXXHyHVKXLXtshkv5qGWAz6t4pIZ_Cd1-tdH4JWG7xDC-vcEEyEw8NwVZ9Ir7dIhLhF/pubhtml";
  const SHEET_PARAMS     = "&single=true&widget=false&headers=false&chrome=false";

  function buildSheetUrl(base, gid) {
    return `${base}?gid=${gid}${SHEET_PARAMS}`;
  }

  // 通常商品: "N営業日出荷" → gid (combo 値から "営業日出荷" を除去したものがキー)
  const NORMAL_GIDS = {
    acrylstand:           { "7": 0,          "8": 355867677,  "9": 1317316660, "10": 1727517095 },
    acrylkeyholder:       { "7": 1155988837, "8": 1517845011, "9": 1363307183, "10": 820304608  },
    acrylstandkeyholder:  { "7": 1382951488, "8": 109595029,  "9": 419009326,  "10": 482720108  },
    acrylplate:           {                                                    "10": 1116840220 },
    acrylclip:            { "7": 1613886449, "8": 204843840,  "9": 470817060,  "10": 1383679073 },
    acrylmagnet:          {                                                    "10": 1783108217 },
  };

  // イベント商品: 「通常納品プラン」「特急納品プラン」→ gid
  // base 商品名 (acrylstand / acrylkeyholder / acrylstandkeyholder) でキー引き
  // m3- / c107- / -event は同一 URL を共有するので alias で管理せずベースだけ持つ
  const EVENT_GIDS_BY_BASE = {
    acrylstand:          { "通常納品プラン": 653601542, "特急納品プラン": 1014937125 },
    acrylkeyholder:      { "通常納品プラン": 200310608, "特急納品プラン": 222049776  },
    acrylstandkeyholder: { "通常納品プラン": 219899631, "特急納品プラン": 1681454372 },
  };

  // 新しいイベント prefix を増やす場合はここに足すだけでいい
  const EVENT_PREFIXES = ["m3-", "c107-"];

  // ===== 2. 商品名から type と base 商品を判定 =====
  function classifyProduct(productName) {
    // (a) -event suffix
    if (productName.endsWith("-event")) {
      const base = productName.slice(0, -"-event".length);
      if (EVENT_GIDS_BY_BASE[base]) return { type: "event", base };
    }
    // (b) m3- / c107- などの prefix
    for (const prefix of EVENT_PREFIXES) {
      if (productName.startsWith(prefix)) {
        const base = productName.slice(prefix.length);
        if (EVENT_GIDS_BY_BASE[base]) return { type: "event", base };
      }
    }
    // (c) 通常商品
    if (NORMAL_GIDS[productName]) return { type: "normal", base: productName };
    return { type: "unknown", base: null };
  }

  // ===== 3. selectedValue から URL を引く =====
  function resolveUrl(productName, selectedValue) {
    const { type, base } = classifyProduct(productName);
    if (type === "event") {
      const gid = EVENT_GIDS_BY_BASE[base]?.[selectedValue];
      return gid != null ? buildSheetUrl(EVENT_SHEET_BASE, gid) : null;
    }
    if (type === "normal") {
      const key = selectedValue.replace("営業日出荷", "");
      const gid = NORMAL_GIDS[base]?.[key];
      return gid != null ? buildSheetUrl(SHEET_BASE, gid) : null;
    }
    return null;
  }

  // ===== 4. DOM 取得 =====
  const productName = new URL(window.location.href).pathname.split("/").pop();
  const comboBox    = document.getElementById("shipping-day-combo-box");
  const iframe      = document.getElementById("priceTable");
  const valueSpan   = document.getElementById("shipping-day-value");

  // 価格表 UI が無いページでは何もしない
  if (!comboBox || !iframe || !valueSpan) return;

  // ===== 5. iframe 切り替え =====
  function setIframeSrc(selectedValue) {
    const url = resolveUrl(productName, selectedValue);
    if (url) {
      iframe.src = url;
    } else {
      iframe.src = "";
      console.error(`[acrylmall-price-table] URL not found: product=${productName}, value=${selectedValue}`);
    }
  }

  comboBox.addEventListener("click", (e) => {
    if (!e.target.classList.contains("combo-box__option-item")) return;
    const selectedValue = e.target.value;
    setIframeSrc(selectedValue);
    updateShippingDayIcon(selectedValue);
  });

  // 初期値
  const initial = comboBox.querySelector('[aria-selected="true"]')?.value;
  if (initial) {
    setIframeSrc(initial);
    updateShippingDayIcon(initial);
  }

  // ===== 6. 営業日アイコン (チェックマーク付き赤丸) を更新 =====
  function updateShippingDayIcon(newValue) {
    valueSpan.innerHTML = `<svg width="14" height="14" class="icon icon--chevron" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><circle cx="7" cy="7" r="7" fill="#ff2020"/><path d="M4 7l2 2 4-4" fill="none" stroke="white" stroke-width="1.5"/></svg>${escapeHtml(newValue)}`;
  }

  // newValue は theme 内の固定文字列由来 (DOM の data-value) で実質安全だが、
  // 将来のソース拡張に備えて防御的に escape する
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
    })[c]);
  }
});
